module.exports = __webpack_public_path__ + "static/media/CAN_event.3187a635.png";